import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchCdr,
  fetchCdrs,
} from "../../actions/callrecorder/cdrsActions";

export interface CdrInterface {
  url: string;

  id: number;
  user_id: number | null;
  rate_id: number | null;
  reminder_activity_id: number | null;
  calldate: string | null;
  start_call: string | null;
  answer: string | null;
  end_call: string | null;
  clid: string | null;
  src: string | null;
  dst: string | null;
  accountcode: string | null;
  dcontext: string | null;
  channel: string | null;
  dstchannel: string | null;
  lastapp: string | null;
  lastdata: string | null;
  duration: number;
  billsec: number;
  disposition: string | null;
  amaflags: number;
  uniqueid: string | null;
  userfield: string | null;
  peeraccount: string | null;
  linkedid: string | null;
  sequence: number;
  ipaddr: string | null;
  call_type: string | null;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<CdrInterface>();

const slice = createSlice({
  name: 'cdrs',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchCdrs.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchCdrs.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.cdrs;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchCdrs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchCdr.fulfilled, (state, action) => {
        const record = Object.values(action.payload.cdr)[0];
        state.entities[record.id] = record;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectCdrById,
  selectIds: selectCdrIds,
  selectEntities: selectCdrEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.cdrs);
